import { FamousInvestorIndex } from "../data/types";
import { InvestorLists } from "./get-investor-list";

type Props = {
  famous: FamousInvestorIndex;
  investorList: InvestorLists;
};
export const getActiveIndex = ({ famous, investorList }: Props): number => {
  // take the index of the first non-disable item as the default index
  const defaultIndex = investorList.findIndex((item) => !item.isDisable);

  // if the item of the famousIndex is disable or cannot be found, return the default index
  if (investorList[famous] == null || investorList[famous].isDisable)
    return defaultIndex;

  return famous;
};
